(() => {
  const DAY_MS = 24 * 60 * 60 * 1000;

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (_) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (_) {
      // The popup still works when storage is unavailable.
    }
  }

  function readSubmission(key) {
    try {
      const data = JSON.parse(window.sessionStorage.getItem(key));
      window.sessionStorage.removeItem(key);
      return data && data.path === window.location.pathname && Date.now() - data.time < 10 * 60 * 1000 ? data : null;
    } catch (_) {
      return null;
    }
  }

  function initPopup(dialog) {
    if (dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';

    const editor = Boolean(window.Shopify && Shopify.designMode);
    const sectionId = dialog.dataset.sectionId;
    const storageKey = `subscribe-popup:${sectionId}`;
    const success = Boolean(dialog.querySelector('[data-subscribe-success]'));
    const error = Boolean(dialog.querySelector('[data-subscribe-error]'));
    const delay = Math.max(0, Number(dialog.dataset.delay) || 0) * 1000;
    const cooldownDays = Math.max(1, Number(dialog.dataset.cooldownDays) || 15);
    const closeButton = dialog.querySelector('[data-subscribe-close]');
    const form = dialog.querySelector('form');
    const submissionKey = `${storageKey}:submitted`;
    const submittedHere = readSubmission(submissionKey);
    let timer;
    let openHeight;

    form.addEventListener('submit', () => {
      try {
        window.sessionStorage.setItem(submissionKey, JSON.stringify({
          path: window.location.pathname,
          time: Date.now(),
          height: openHeight || dialog.getBoundingClientRect().height
        }));
      } catch (_) {
        // Native form submission still works when storage is unavailable.
      }
    });

    function show() {
      if (!dialog.open) {
        dialog.showModal();
        document.body.classList.add('subscribe-popup-open');
        if (!success) openHeight = dialog.getBoundingClientRect().height;
      }
    }

    function hide() {
      if (dialog.open) dialog.close();
    }

    closeButton.addEventListener('click', hide);
    dialog.addEventListener('cancel', (event) => event.preventDefault());

    dialog.addEventListener('close', () => {
      document.body.classList.remove('subscribe-popup-open');
      if (editor) return;
      if (success) {
        writeStorage(`${storageKey}:subscribed`, 'true');
      } else {
        writeStorage(`${storageKey}:dismissed`, String(Date.now()));
      }
    });

    if (editor) {
      const onSelect = (event) => {
        if (event.detail.sectionId === sectionId) show();
      };
      const onDeselect = (event) => {
        if (event.detail.sectionId === sectionId) hide();
      };
      document.addEventListener('shopify:section:select', onSelect);
      document.addEventListener('shopify:section:deselect', onDeselect);
      const onUnload = (event) => {
        if (event.detail.sectionId !== sectionId) return;
        clearTimeout(timer);
        document.removeEventListener('shopify:section:select', onSelect);
        document.removeEventListener('shopify:section:deselect', onDeselect);
        document.removeEventListener('shopify:section:unload', onUnload);
        if (dialog.open) hide();
      };
      document.addEventListener('shopify:section:unload', onUnload);
      return;
    }

    if ((success || error) && submittedHere) {
      if (success && Number.isFinite(submittedHere.height) && submittedHere.height > 0) {
        dialog.style.height = `${Math.round(submittedHere.height)}px`;
        dialog.classList.add('subscribe-popup--matched-height');
      }
      show();
      return;
    }

    // Other newsletter forms on the page can share Shopify's customer form result.
    if (success || error) return;

    if (dialog.dataset.ready !== 'true' || readStorage(`${storageKey}:subscribed`) === 'true') return;

    const dismissedAt = Number(readStorage(`${storageKey}:dismissed`));
    if (Number.isFinite(dismissedAt) && dismissedAt > 0 && Date.now() - dismissedAt < cooldownDays * DAY_MS) return;

    timer = window.setTimeout(show, delay);
  }

  function initAll(root = document) {
    if (root.matches && root.matches('[data-subscribe-popup]')) initPopup(root);
    root.querySelectorAll('[data-subscribe-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  if (!window.subscribePopupEditorListenerAdded) {
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    window.subscribePopupEditorListenerAdded = true;
  }
})();
